import React from "react";

function CommentIcon({width="20px", height="20px"}) {
    return (
        <svg viewBox="0 0 18 17"
        width={width}
        height={height}
         xmlns="http://www.w3.org/2000/svg"
         class="css-1apqftv">
            <path d="M10.446.843H7.962A7.151 7.151 0 0 0 .805 8v8.63c0 .926 1.347-1.473 2.947-1.473h6.693c3.958 0 7.157-3.2 7.157-7.157A7.15 7.15 0 0 0 10.446.843Zm2.336 10.314H5.625a.62.62 0 0 1-.631-.631.62.62 0 0 1 .631-.632h7.157a.62.62 0 0 1 .632.632.62.62 0 0 1-.632.631Zm0-2.315H5.625a.62.62 0 0 1-.631-.632.62.62 0 0 1 .631-.631h7.157a.62.62 0 0 1 .632.631.62.62 0 0 1-.632.632Zm0-2.316H5.625a.62.62 0 0 1-.631-.631.62.62 0 0 1 .631-.632h7.157a.62.62 0 0 1 .632.632.62.62 0 0 1-.632.631Z" 
        fill="currentColor"></path></svg>
    );
  }

export default CommentIcon;